import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { StoreService } from '@se-po/se-household-setup-data-access-store'
import { AnalyticsService } from '@se-po/shared-data-access-services'
import { SetupBarService } from '@se-po/shared-ui-setup-bar'

@Component({
  selector: 'se-po-guardian-invite',
  templateUrl: './guardian-invite.component.html',
  styleUrls: ['./guardian-invite.component.scss'],
})
export class GuardianInviteComponent implements OnInit {
  public storeLoaded = false
  public profile: any
  public prohibitedEmails: string[] = []
  private readonly app = 'SingleSignOn'
  private readonly page = 'HouseholdSetup'
  private readonly label = 'InviteGuardian'

  constructor(
    private analyticsService: AnalyticsService,
    public setupBarService: SetupBarService,
    public store: StoreService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.profile = this.store.childInfo
    this.handleExistingEmails()
    this.setupBarService.setAttributes({
      title: 'Create Account',
      percentComplete: 65
    })
    this.storeLoaded = true
    this.analyticsService.pageView(this.app, this.page, this.label)
  }

  public handleExistingEmails(): void {
    if (!this.store.draftGuardianInvites.value) {
      this.store.draftGuardianInvites.next([])
    }
    this.prohibitedEmails = this.store.draftGuardianInvites.value.map((invite) => invite.to)
    this.prohibitedEmails.push(this.store.accountInfo.email)
  }

  public handleInvite(event): void {
    if(!this.store.draftGuardianInvites.value) {
      this.store.draftGuardianInvites.next([])
    }
    if (event) {
      this.analyticsService.seEvent(`${this.page}.${this.label}.SendInvite`)
      const invite = { ...event, to: event.email }
      this.store.draftGuardianInvites.next([...this.store.draftGuardianInvites.value, invite])
    } else {
      this.analyticsService.seEvent(`${this.page}.${this.label}.Skip`)
    }

    void this.router.navigate([this.store.basePath, 'review'])
  }
}
